import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../../../redux/slices/login-slice";
import { login } from "../../../../../apis/login-api";

type ResendCodeProps = {
    clearForm: () => void;
};

function ResendCode({ clearForm }: ResendCodeProps) {
    const [minutes, setMinutes] = useState(3);
    const [seconds, setSeconds] = useState(0);
    const items: any = useSelector(selectUser);

    const ResendOTP = async () => {
        try {
            const { data: auth }: any = await login(items.username, items.password)
            console.log(auth)
        } catch (error) {
            console.log(error)
        }
        setMinutes(3);
        setSeconds(0);
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else if (minutes > 0) {
                setMinutes(minutes - 1);
                setSeconds(59);
            } else {
                clearInterval(interval);
            }
        }, 1000);

        return () => {
            clearInterval(interval);
        };
    }, [seconds]);

    return (
        <div className='w-100 mt-4 d-flex justify-content-center justify-content-center'>
            {seconds > 0 || minutes > 0 ? (
                <p>زمان باقی مانده {' '}
                    {minutes < 10 ? `0${minutes}` : minutes}:
                    {seconds < 10 ? `0${seconds}` : seconds}
                </p>
            ) : (
                <p>کد را دریافت نکرده اید؟</p>
            )}
            <a className='px-2 cursor-pointer' onClick={ResendOTP}>ارسال مجدد کد</a>
        </div>
    );
}

export default ResendCode;
